import React, { useEffect, useState } from 'react';
import Nav from '../../components/Nav';
import DinamicTable from '../../components/DinamicTable';
import DashboardSidebar from '../../components/DashboardSidebar';
import ApiService from '../../services/ApiService';

const CloneDashList = () => {

    const [active, setActive] = useState(true);
    const [clones, setClones] = useState([]);
    const [filter, setFilter] = useState({ page: 1, pages: 0, limit: 5, isLoading: false, search: '' });

    const tableColumns = ["#", "Avatar", "Name", "Surname", "Created By", "Chat", "Action"];

    const getClones = async () => {
        try {
            setFilter((prev) => ({ ...prev, isLoading: true }));
            const response = await ApiService.get(`/cms/clones?page=${filter?.page}&limit=${filter?.limit}&name=${filter?.search}`);
            setFilter((prev) => ({ ...prev, pages: response?.totalPages }));
            setClones(
                response?.contents?.map((clone,index) => ({
                    _id: clone?._id ,
                    image: clone?.data?.picture?.media || '/images/avatar/avatar-default.jpg',
                    name: clone?.data?.name || "N/A",
                    surname: clone?.data?.surname || "N/A",

                    createdBy: clone?.author?.username || "N/A",
                })) || []
            );
        } catch (err) {
            console.error("Error fetching clones:", err);
        } finally {
            setFilter((prev) => ({ ...prev, isLoading: false }));
        }
    };

    useEffect(() => {
        if (filter?.isLoading === false) {
            getClones();
        }
    }, [filter?.page, filter?.search]);

    return (
        <div className="tyn-root dashboard">
            <Nav />
            <div className="tyn-content tyn-content-full-height tyn-chatbot tyn-chatbot-page has-aside-base">
                <DashboardSidebar active="Clone List" setter={setActive} />
                <div className={`tyn-main tyn-content-inner ${active && 'main-shown' || ''}`} id="tynMain">
                <ul className="tyn-list-inline d-md-none translate-middle position-absolute start-50 z-1">
                        <li>
                            <button className="btn btn-icon btn-pill btn-white js-toggle-main" onClick={() => setActive(false)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                                    <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                                </svg>
                            </button>
                        </li>
                    </ul>
                    <DinamicTable
                        data={clones}
                        title="Clone List"
                        tableColumns={tableColumns}
                        addLink="/add-clone"
                        editLink="/edit-clone/"
                        customLink="/chat/"
                        filter={filter}
                        setFilter={setFilter}
                    />
                </div>
            </div>
        </div>
    );
};

export default CloneDashList;
